export const ANNOTATION_ELEMENT_LINE = 'LINE';
export const ANNOTATION_ELEMENT_RECTANGLE = 'RECTANGLE';
export const ANNOTATION_ELEMENT_ARROW = 'ARROW';
export const ANNOTATION_ELEMENT_ELLIPSE = 'ELLIPSE';
export const ANNOTATION_ELEMENT_PENCIL = 'PENCIL';
export const ANNOTATION_ELEMENT_TEXT = 'TEXT';
export const ANNOTATION_ELEMENT_LASER = 'LASER';
export const ANNOTATION_ELEMENT_CROSS = 'CROSS';
export const DRAW_TOOL_SELECT = 'SELECT';
export const PANNING_TOOL = 'PAN';
export const ZOOM_TOOL = 'ZOOM';
export const PLAY_TOOL = 'PLAY';

export const ANNOTATION_ELEMENT_TYPES = [
  ANNOTATION_ELEMENT_LINE,
  ANNOTATION_ELEMENT_RECTANGLE,
  ANNOTATION_ELEMENT_ARROW,
  ANNOTATION_ELEMENT_ELLIPSE,
  ANNOTATION_ELEMENT_PENCIL,
  ANNOTATION_ELEMENT_TEXT,
  ANNOTATION_ELEMENT_LASER,
  ANNOTATION_ELEMENT_CROSS,
] as const;

export const DRAW_TOOLS = [
  ...ANNOTATION_ELEMENT_TYPES,
  DRAW_TOOL_SELECT,
] as const;

export const TRANSFORMATION_TOOLS = [PANNING_TOOL, ZOOM_TOOL] as const;

export const CONTROL_TOOLS = [PLAY_TOOL] as const;

export const TEXT_SELECT_TOOL = 'TEXT_SELECT';

export const TEXT_SELECTION_TOOLS = [TEXT_SELECT_TOOL] as const;

export const PLAYER_FEATURES = [
  'playbackrate',
  'subtitles',
  'compare',
  'point_in',
  'point_out',
  'undo',
  'redo',
  'show_actual_size',
  'fullscreen',
  'volume',
  'audio_meter',
  'player_background_color',
  'flip',
  'flop',
  'rotate_counter_clockwise',
  'rotate_clockwise',
  'tracing_layer',
  'print',
  'search',
  'audio_mixer',
  'text_select',
  'tool_select',
  'tool_zoom',
  'tool_pan',
  'tool_pencil',
  'tool_arrow',
  'tool_ellipse',
  'tool_rectangle',
  'tool_line',
  'tool_cross',
  'tool_text',
  'tool_laser',
] as const;

export const MIN_ZOOM = 0.1;

export const MAX_ZOOM = 8;

export const TRANSPARENT_CONTENT_TYPES = ['image', 'video'];

export const VISUAL_CONTENT_TYPES = ['image', 'video', 'stream'];

export const AUDIO_MIXER_MIN_CHANNELS = 3;

export const AUDIO_MIXER_MAX_CHANNELS = 16;

export const LIVE_EDGE_THRESHOLD_SECONDS = 5;

// Far enough back to land inside the newest segment rather than on its trailing
// edge, where there is nothing buffered ahead to play into
export const LIVE_EDGE_SEEK_OFFSET_SECONDS = 2;
